import React from 'react';

import type { HTMLProps, ReactNode } from 'react';

import cx from '../../utils/classNames';
import toCamelCase from '../../utils/toCamelCase';

import styles from './textField.module.scss';

export type Props = {
  /** `className` applies styles to the input wrapper element. */
  className?: string;
  /** The content of the component, typically children elements like input, label, etc. */
  children: ReactNode;
} & HTMLProps<HTMLDivElement>;

export function TextField(props: Props) {
  const { className, children, ...rest } = props;

  return (
    <div className={cx(styles[toCamelCase('textField', 'container')], className)} {...rest}>
      {children}
    </div>
  );
}
export default TextField;
